var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2214 8.44014H17.5501V8.40556H10.0501V11.7389H14.7597C14.0726 13.6793 12.2264 15.0722 10.0501 15.0722C7.28888 15.0722 5.05013 12.8335 5.05013 10.0722C5.05013 7.31098 7.28888 5.07222 10.0501 5.07222C11.3247 5.07222 12.4843 5.55306 13.3672 6.33847L15.7243 3.98139C14.236 2.59431 12.2451 1.73889 10.0501 1.73889C5.44805 1.73889 1.7168 5.47014 1.7168 10.0722C1.7168 14.6743 5.44805 18.4056 10.0501 18.4056C14.6522 18.4056 18.3835 14.6743 18.3835 10.0722C18.3835 9.51347 18.326 8.96806 18.2214 8.44014Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67749 6.19348L5.41541 8.20139C6.15624 6.36723 7.95041 5.07223 10.05 5.07223C11.3246 5.07223 12.4842 5.55306 13.3671 6.33847L15.7242 3.98139C14.2358 2.59431 12.245 1.73889 10.05 1.73889C6.84916 1.73889 4.07332 3.54597 2.67749 6.19348Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0501 18.4056C12.2026 18.4056 14.1584 17.5819 15.6372 16.2423L13.058 14.0598C12.1932 14.7175 11.1365 15.0732 10.0501 15.0723C7.8826 15.0723 6.04218 13.6902 5.34885 11.7615L2.63135 13.8552C4.01051 16.554 6.81135 18.4056 10.0501 18.4056Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2213 8.44022H17.55V8.40564H10.05V11.739H14.7596C14.431 12.6625 13.8389 13.4695 13.0567 14.0602L13.058 14.0594L15.6371 16.2419C15.4546 16.4077 18.3834 14.239 18.3834 10.0723C18.3834 9.51356 18.3259 8.96814 18.2213 8.44022Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ca26b4a56c2dccbac4f24bed80eb19a5.svg";
export { ForwardRef as ReactComponent };